import { render, staticRenderFns } from "./EditContractValueCluster.vue?vue&type=template&id=60034aee&"
import script from "./EditContractValueCluster.vue?vue&type=script&lang=js&"
export * from "./EditContractValueCluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports